import { Slider as AntdSlider, SliderSingleProps as AntdSliderSingleProps, ConfigProvider } from 'antd';
import { SliderRangeProps } from 'antd/es/slider';
import { useTheme } from '../../theme/ThemeContext';

export type SliderProps = (AntdSliderSingleProps | SliderRangeProps) & {'data-test'?: string;'data-test-id'?: string;};

const Slider: React.FC<SliderProps> = ({ ...props }) => {
    const theme = useTheme();
    return (
        <ConfigProvider theme={theme}>
            <AntdSlider {...props} data-test={props['data-test']} data-test-id={props['data-test-id']} data-asper-slider/>
        </ConfigProvider>
    );
};

export default Slider;
